import { ref } from 'vue';

const isOpen = ref(false);
const message = ref('');
let resolveFn: (value: boolean) => void;

export function useConfirm() {
  const confirm = (msg: string): Promise<boolean> => {
    message.value = msg;
    isOpen.value = true;

    return new Promise((resolve) => {
      resolveFn = resolve;
    });
  };

  const handleConfirm = () => {
    isOpen.value = false;
    resolveFn(true);
  };

  const handleCancel = () => {
    isOpen.value = false;
    resolveFn(false);
  };

  return {
    isOpen,
    message,
    confirm,
    handleConfirm,
    handleCancel,
  };
}
